import { useQuery } from "@tanstack/react-query";
import getAvailableTimeSlots, { Params } from "api/bookAppointmentOnline/get-available-time-slots";
import { CONTEXT_TYPES } from "api/bookAppointmentOnline/get-book-appointment-dashboard-items";

export const AVAILABLE_TIME_SLOTS_QUERY_KEY = "availableTimeSlotsList";

type HookParams = {
    isModalOpen: boolean
} & Params;

export default function useGetAvailableTimeSlots({ doctorId, typeId, date, context, contextId, isModalOpen }: HookParams) {
    const enabled = isModalOpen &&
    (context === CONTEXT_TYPES.CONTEXT_DOCTOR ? (!!typeId && !!date) : (!!date));

    return useQuery({
        queryKey: [AVAILABLE_TIME_SLOTS_QUERY_KEY, doctorId, typeId, date, context, contextId],
        queryFn: () => getAvailableTimeSlots({ doctorId, typeId, date, context, contextId }),
        enabled: enabled,
        placeholderData: isModalOpen ? (prev) => prev : undefined
    });
};
